import { connect } from 'react-redux';
import { getAltText, getNotes } from '../selectors';
import { getName, getIllustration, getIsDouble } from '../selectors/door';
import { getSummaryFieldValues, getOptionThumbnails } from '../selectors/hybrid';
import DoorSummary from '../components/DoorSummary';

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return {
    name: getName(configuratorState),
    illustration: getIllustration(configuratorState),
    imageAltText: getAltText(configuratorState),
    isDouble: getIsDouble(configuratorState),
    summaryValues: getSummaryFieldValues(configuratorState),
    thumbnails: getOptionThumbnails(configuratorState),
    notes: getNotes(configuratorState)
  };
};

const DoorSummaryContainer = connect(
  mapStateToProps
)(DoorSummary);

export default DoorSummaryContainer;
